<script>
import { required } from "vuelidate/lib/validators";
export default {
    name: "GroupItemForm",
    props: {
        sectionData: {
            type: Object,
            default: () => ({
                id: 0,
                name: null,
                description: null,
                otherVariables: null,
                sort: null,
            }),
        },
    },
    validations: {
        formData: {
            name: { required },
        },
    },
    data() {
        return {
            submitted: false,
            formData: { ...this.sectionData },
            isEditMode: !!this.sectionData.id,
        };
    },
    methods: {
        async submitForm() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$emit("submit", this.formData);
        },
    },
}

</script>
<template>
    <form @submit.prevent="submitForm">
        <div class="mb-3 d-flex gap-1 align-items-end">
            <div class="flex-grow-1">
                <label for="groupItemName" class="form-label">Group Item Name</label>
                <input
                    type="text"
                    id="groupItemName"
                    v-model="formData.name"
                    class="form-control"
                    autocomplete="off"
                    :class="{ 'is-invalid': submitted && $v.formData.name.$invalid }"
                />
                <div v-if="submitted && $v.formData.name.$invalid" class="invalid-feedback">
                    Group item name is required.
                </div>
            </div>
            <div class="flex-grow-1">
                <label for="groupItemDescription" class="form-label">Description</label>
                <input
                    type="text"
                    id="groupItemDescription"
                    v-model="formData.description"
                    class="form-control"
                    autocomplete="off"
                />
            </div>
            <div class="flex-grow-1">
                <label for="otherVariables" class="form-label">Other Variables</label>
                <input
                    type="text"
                    id="otherVariables"
                    v-model="formData.otherVariables"
                    class="form-control"
                    autocomplete="off"
                />
            </div>
            <div class="d-flex gap-1">
                <button type="submit" class="btn btn-outline-success d-flex align-items-center gap-1">
                    <i class="bx bx-save font-size-18"></i>
                </button>
                <button type="button" class="btn btn-outline-secondary d-flex align-items-center gap-1" @click="$emit('cancel')">
                    <i class="bx bx-x font-size-18"></i>
                </button>
            </div>
        </div>
    </form>
</template>